export default "__VITE_ASSET__MQvIl9tt__"